module.exports = __webpack_public_path__ + "static/img/Picture2.6c47be2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191014/Picture2.jpg
// module id = VAP2
// module chunks = 1